export default {
  status: 'eventNoMap',
  selected: {},
  playing: null
}
